import { render, staticRenderFns } from "./SkeletonImage.vue?vue&type=template&id=810b3720"
import script from "./SkeletonImage.vue?vue&type=script&lang=js"
export * from "./SkeletonImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports